import React, { FC, DOMAttributes } from 'react';

import styled from '@emotion/styled';
import {
  compose,
  typography,
  space,
  color,
  variant,
  TypographyProps,
  SpaceProps,
  ColorProps,
  layout,
  LayoutProps,
  ComponentsType,
} from '@lucid/theme';

export interface BlockquoteProps
  extends ColorProps,
    LayoutProps,
    SpaceProps,
    TypographyProps,
    DOMAttributes<HTMLElement> {
  /** Allows the component to get additional styles. */
  className?: string;
  /** The available variants for the Text component. */
  variant?: ComponentsType['Quote']['Blockquote'];
}

const blockquoteStyleProps = compose(color, layout, space, typography);

const StyledBlockquote: FC<BlockquoteProps> = styled.blockquote(
  variant({
    scale: 'quote.blockquote',
    variants: {
      defaultVariant: {},
    },
  }),
  ({ theme }) => ({
    label: 'blockquote',
    blockquote: {
      margin: 0,
    },
    p: {
      color: theme.colors.coolGrey[50],
      paddingLeft: theme.space.s16,
    },
    borderLeft: `solid ${theme.colors.coolGrey[50]} 4px`,
  }),
  blockquoteStyleProps,
);

const Blockquote: FC<BlockquoteProps> = ({ className, variant = 'default', children, ...rest }) => (
  <StyledBlockquote {...rest} className={className} variant={variant}>
    {children}
  </StyledBlockquote>
);

export { Blockquote };
export default Blockquote;
